import { Navigate, Outlet } from 'react-router-dom';
import { useStore } from '@shared/hooks/useStore';
import { ROUTES } from '@shared/configs/constants';
import AdminHeader from '@admin/components/layout/AdminHeader';
import AdminFooter from '@admin/components/layout/AdminFooter';
import AdminProfileSidebar from '@admin/components/layout/AdminProfileSidebar';

const AdminProfileLayout = () => {
    const { authStore: { isLoggedIn } } = useStore();
    if (!isLoggedIn) {
        return <Navigate to={ROUTES.home.href} replace />;
    }
    return (
        <div className='flex flex-col min-h-screen bg-[#F1F1F1]'>
            {/* Header */}
            <AdminHeader />

            {/* Main Content Area */}
            <div className='flex-1 container mx-auto p-4 pb-10 md:px-6 md:pt-8 md:pb-20 grid lg:grid-cols-[320px_1fr] gap-6 lg:gap-10 text-break'>
                {/* Sidebar */}
                <aside className='hidden sticky h-fit lg:block'>
                    <AdminProfileSidebar />
                </aside>

                {/* Main Content */}
                <main className='w-full min-h-[calc(100vh-200px)]'>
                    <Outlet />
                </main>
            </div>

            {/* Footer */}
            <AdminFooter />
        </div>
    );
};

export default AdminProfileLayout;
